interface SimpleToastProps {
  id: string;
  classname?: string;
  role?: string;
  header: boolean;
  headerText?: string;
  headerClass?: string;
  headerIcon?: string;
  headerIconClass?: string;
  headerSmallText?: string;
  bodyClass?: string;
  bodyText: string;
  width?: string;
}

export const SimpleToast = ({
  id,
  width,
  classname,
  role,
  header,
  headerClass,
  headerIcon,
  headerIconClass,
  headerText,
  headerSmallText,
  bodyClass,
  bodyText,
}: SimpleToastProps) => {
  return (
    <div
      className={`toast ${classname ?? ''}`}
      id={id}
      role={role ?? 'alert'}
      aria-live="assertive"
      aria-atomic="true"
      style={width ? { width } : {}}
    >
      {header && (
        <div className={`toast-header ${headerClass ?? ''}`}>
          {headerIcon && (
            <img src={headerIcon} className={headerIconClass ?? 'rounded me-2'} alt="" />
          )}
          <strong className="me-auto">{headerText}</strong>
          {headerSmallText && <small>{headerSmallText}</small>}
          <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close" />
        </div>
      )}
      <div className={`toast-body ${bodyClass ?? ''}`}>{bodyText}</div>
    </div>
  );
};
